import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import InputTextField from "./InputTextField";
import { PiArrowFatUpThin, PiArrowFatDownThin } from "react-icons/pi";
import { FULL_API_BASE_URL } from "../../Config/Config";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import InterogativeImg from "../../Assets/Images/CommanImages/Informative.png";
import "./newtest.css";

function CreateTestSection({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) {
  const [value, setValues] = useState({
    test_section_name: "",
    test_section_desc: "",
    test_section_instructions: "",
    marking_scheme: "Basic",
    correct_ques_level_marks: "NA",
    wrong_ques_level_marks: "NA",
    correct_option_level_marks: "NA",
    wrong_option_level_marks: "NA",
    unattempted_marks: "NA",
  });

  const [rows, setRows] = useState([
    {
      id: 1,
      label: "Correct - Question Level",
      name: "correct_ques_level_marks",
      value: value.correct_ques_level_marks,
    },
    {
      id: 2,
      label: "Wrong - Question Level",
      name: "wrong_ques_level_marks",
      value: value.wrong_ques_level_marks,
    },
    {
      id: 3,
      label: "Correct - Option Level",
      name: "correct_option_level_marks",
      value: value.correct_option_level_marks,
    },
    {
      id: 4,
      label: "Wrong Option Level",
      name: "wrong_option_level_marks",
      value: value.wrong_option_level_marks,
    },
    {
      id: 5,
      label: "Unattempted",
      name: "unattempted_marks",
      value: value.unattempted_marks,
    },
  ]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setRows((prevRows) =>
      prevRows.map((row) => (row.name === name ? { ...row, value } : row))
    );
  };

  const moveRowUp = () => {
    if (selectedRowIndex !== null && selectedRowIndex > 0) {
      const updatedRows = [...rows];
      [updatedRows[selectedRowIndex - 1], updatedRows[selectedRowIndex]] = [
        updatedRows[selectedRowIndex],
        updatedRows[selectedRowIndex - 1],
      ];
      setRows(updatedRows);
      setSelectedRowIndex(selectedRowIndex - 1);
    }
  };

  const moveRowDown = () => {
    if (selectedRowIndex !== null && selectedRowIndex < rows.length - 1) {
      const updatedRows = [...rows];
      [updatedRows[selectedRowIndex + 1], updatedRows[selectedRowIndex]] = [
        updatedRows[selectedRowIndex],
        updatedRows[selectedRowIndex + 1],
      ];
      setRows(updatedRows);
      setSelectedRowIndex(selectedRowIndex + 1);
    }
  };

  const selectRow = (index) => {
    setSelectedRowIndex((prevSelectedIndex) =>
      prevSelectedIndex === index ? null : index
    );
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const handleFocus = (e) => {
    const { name } = e.target;
    if (value[name] === "NA") {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: "",
      }));

      setRows((prevRows) =>
        prevRows.map((row) => (row.name === name ? { ...row, value: "" } : row))
      );
    }
  };

  const handleBlur = (e) => {
    const { name, value: inputValue } = e.target;
    if (inputValue === "") {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: "NA",
      }));

      setRows((prevRows) =>
        prevRows.map((row) =>
          row.name === name ? { ...row, value: "NA" } : row
        )
      );
    }
  };

  // const handleCreate = () => {
  //     let payload = {
  //         test_section_name: value.test_section_name,
  //         test_section_desc: value.test_section_desc,
  //         test_section_instructions: value.test_section_instructions,
  //         created_by: "shashi",
  //         create_date: new Date().toISOString(),
  //         last_updated_by: "shashi",
  //         last_updated_on: new Date().toISOString(),
  //         status: 1,
  //     };

  //     if (value.marking_scheme === "Basic") {
  //         payload.correct_ques_level_marks = value.correct_ques_level_marks === "NA" ? 0 : parseInt(value.correct_ques_level_marks, 10);
  //         payload.wrong_ques_level_marks = value.wrong_ques_level_marks === "NA" ? 0 : parseInt(value.wrong_ques_level_marks, 10);
  //     } else if (value.marking_scheme === "Advanced") {
  //         payload.correct_ques_level_marks = parseInt(rows.find(row => row.name === "correct_ques_level_marks").value, 10);
  //         payload.correct_ques_level_order = rows.findIndex(row => row.name === "correct_ques_level_marks") + 1;
  //         payload.wrong_ques_level_marks = parseInt(rows.find(row => row.name === "wrong_ques_level_marks").value, 10);
  //         payload.wrong_ques_level_order = rows.findIndex(row => row.name === "wrong_ques_level_marks") + 1;
  //         payload.correct_option_level_marks = parseInt(rows.find(row => row.name === "correct_option_level_marks").value, 10);
  //         payload.correct_option_level_order = rows.findIndex(row => row.name === "correct_option_level_marks") + 1;
  //         payload.wrong_option_level_marks = parseInt(rows.find(row => row.name === "wrong_option_level_marks").value, 10);
  //         payload.wrong_option_level_order = rows.findIndex(row => row.name === "wrong_option_level_marks") + 1;
  //         payload.unattempted_marks = parseInt(rows.find(row => row.name === "unattempted_marks").value, 10);
  //         payload.unattempted_order = rows.findIndex(row => row.name === "unattempted_marks") + 1;
  //     }

  //     fetch(`${FULL_API_BASE_URL}/create-test-section`, {
  //         method: "POST",
  //         headers: {
  //             "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //     })
  //         .then((response) => response.json())
  //         .then((data) => {
  //             if (data.result === "success") {
  //                 Swal.fire("Success!", "Test section created successfully!", "success");
  //             } else {
  //                 Swal.fire("Error", data.message || "Failed to create test section. Please check your input data.", "error");
  //             }
  //         })
  //         .catch((error) => {
  //             Swal.fire("Error", "An error occurred: " + error.message, "error");
  //         });
  // };

  const handleCreate = () => {
    if (
      !value.test_section_name.trim() ||
      !value.test_section_desc.trim() ||
      !value.test_section_instructions.trim()
    ) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div
          className="Container-messageBOX"
          onMouseEnter={pauseTimer}
          onMouseLeave={resumeTimer}
        >
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Please fill out all required fields: Section Name, Description,
              and Instructions.
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);
      return;
    }

    if (value.marking_scheme === "Basic") {
      if (
        value.correct_ques_level_marks === "NA" ||
        !value.correct_ques_level_marks.trim() ||
        value.wrong_ques_level_marks === "NA" ||
        !value.wrong_ques_level_marks.trim()
      ) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please enter values for Basic Marking Scheme: Correct and Wrong
                Marks.
              </span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }
    } else if (value.marking_scheme === "Advanced") {
      if (
        value.correct_ques_level_marks === "NA" ||
        !value.correct_ques_level_marks.trim() ||
        value.wrong_ques_level_marks === "NA" ||
        !value.wrong_ques_level_marks.trim() ||
        value.correct_option_level_marks === "NA" ||
        !value.correct_option_level_marks.trim() ||
        value.wrong_option_level_marks === "NA" ||
        !value.wrong_option_level_marks.trim()
      ) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please enter values for Advanced Marking Scheme: Question level
                correct/wrong and Option level correct/wrong Marks.
              </span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }
    }
    let payload = {
      test_section_name: value.test_section_name,
      test_section_desc: value.test_section_desc,
      test_section_instructions: value.test_section_instructions,
      created_by: "shashi",
      create_date: new Date().toISOString(),
      last_updated_by: "shashi",
      last_updated_on: new Date().toISOString(),
      status: 1,
    };

    if (value.marking_scheme === "Basic") {
      payload.correct_ques_level_marks =
        value.correct_ques_level_marks === "NA"
          ? 0
          : parseInt(value.correct_ques_level_marks, 10);
      payload.wrong_ques_level_marks =
        value.wrong_ques_level_marks === "NA"
          ? 0
          : parseInt(value.wrong_ques_level_marks, 10);
    } else if (value.marking_scheme === "Advanced") {
      payload.correct_ques_level_marks = parseInt(
        rows.find((row) => row.name === "correct_ques_level_marks").value,
        10
      );
      payload.correct_ques_level_order =
        rows.findIndex((row) => row.name === "correct_ques_level_marks") + 1;
      payload.wrong_ques_level_marks = parseInt(
        rows.find((row) => row.name === "wrong_ques_level_marks").value,
        10
      );
      payload.wrong_ques_level_order =
        rows.findIndex((row) => row.name === "wrong_ques_level_marks") + 1;
      payload.correct_option_level_marks = parseInt(
        rows.find((row) => row.name === "correct_option_level_marks").value,
        10
      );
      payload.correct_option_level_order =
        rows.findIndex((row) => row.name === "correct_option_level_marks") + 1;
      payload.wrong_option_level_marks = parseInt(
        rows.find((row) => row.name === "wrong_option_level_marks").value,
        10
      );
      payload.wrong_option_level_order =
        rows.findIndex((row) => row.name === "wrong_option_level_marks") + 1;
      payload.unattempted_marks = parseInt(
        rows.find((row) => row.name === "unattempted_marks").value,
        10
      );
      payload.unattempted_order =
        rows.findIndex((row) => row.name === "unattempted_marks") + 1;
    }

    fetch(`${FULL_API_BASE_URL}/create-test-section`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result === "success") {
          Swal.fire(
            "Success!",
            "Test section created successfully!",
            "success"
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">CREATE SECTION</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleCreate}>
            CREATE
          </button>
        </div>
      </div>
      {/* Section Details Accordion */}
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Section Details</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="grid-container-test-module" style={{ width: "80%" }}>
            <div className="grid-item">
              <InputTextField
                label="Section Name"
                type="text"
                name="test_section_name"
                value={value.test_section_name}
                onChange={handleInputChange}
                required
                alignItem="center"
              />
            </div>
            <div className="grid-item">
              <InputTextField
                label="Description"
                type="text"
                name="test_section_desc"
                value={value.test_section_desc}
                onChange={handleInputChange}
                required
                alignItem="center"
              />
            </div>
            <div className="grid-item-3">
              <InputTextField
                label="Instructions"
                type="textarea"
                name="test_section_instructions"
                value={value.test_section_instructions}
                onChange={handleInputChange}
                required
                alignItem="flex-start"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Marking Scheme Accordion */}
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <h2>Marking Scheme</h2>
          </div>
        </div>
        <div className="accordion-content">
          <div className="grid-container-test-sheme" style={{ width: "80%" }}>
            <div className="marking-scheme">
              <div className="toggle-radio">
                <input
                  type="radio"
                  id="basic"
                  name="marking_scheme"
                  value="Basic"
                  checked={value.marking_scheme === "Basic"}
                  onChange={(e) =>
                    setValues({ ...value, marking_scheme: e.target.value })
                  }
                />
                <label htmlFor="basic">Basic</label>
              </div>
              <div className="toggle-radio">
                <input
                  type="radio"
                  id="advanced"
                  name="marking_scheme"
                  value="Advanced"
                  checked={value.marking_scheme === "Advanced"}
                  onChange={(e) =>
                    setValues({ ...value, marking_scheme: e.target.value })
                  }
                />
                <label htmlFor="advanced">Advanced</label>
              </div>
            </div>
            {/* Marking Scheme Table */}
            <div className="marking-table">
              {value.marking_scheme === "Basic" && (
                <div
                  className="basic-marking"
                  style={{ marginLeft: "220px", marginTop: "-31px" }}
                >
                  <table className="score-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Marks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Correct</td>
                        <td>
                          <input
                            type="text"
                            name="correct_ques_level_marks"
                            value={value.correct_ques_level_marks}
                            onChange={handleInputChange}
                            className="table-input"
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            pattern="\d{1,2}"
                            maxLength="2"
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Wrong</td>
                        <td>
                          <input
                            type="text"
                            name="wrong_ques_level_marks"
                            value={value.wrong_ques_level_marks}
                            onChange={handleInputChange}
                            className="table-input"
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            pattern="^-?(0|[1-9]\d*)$"
                            maxLength="3"
                            onInput={(e) => {
                              let val = e.target.value;
                              if (val === "") {
                                e.target.value = "";
                              }
                              // Allow only negative numbers or zero
                              else if (val !== "0" && !val.startsWith("-")) {
                                e.target.value =
                                  "-" + val.replace(/[^0-9]/g, "");
                              } else {
                                e.target.value = val.replace(/[^-0-9]/g, "");
                              }
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              {value.marking_scheme === "Advanced" && (
                <div
                  className="marking-table"
                  style={{ marginLeft: "220px", marginTop: "-31px" }}
                >
                  <table className="score-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Marks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr
                          key={row.id}
                          className={
                            selectedRowIndex === index ? "selected-row" : ""
                          }
                        >
                          <td
                            onClick={() => selectRow(index)}
                            style={{ cursor: "pointer" }}
                          >
                            {row.label}
                          </td>
                          <td>
                            {/* <input
                                                                type="text"
                                                                name={row.name}
                                                                value={row.value}
                                                                onChange={handleInputChange}
                                                                onFocus={handleFocus}
                                                                onBlur={handleBlur}
                                                                pattern="^-?\d{1,2}$"
                                                                maxLength="3"
                                                                className="table-input"
                                                                onInput={(e) => e.target.value = e.target.value.replace(/[^-0-9]/g, '')}
                                                            /> */}
                            <input
                              type="text"
                              name={row.name}
                              value={row.value}
                              onChange={(e) => handleInputChange(e, index)}
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              pattern={
                                row.name === "unattempted_marks"
                                  ? "0"
                                  : "^-?(0|[1-9]d*)$"
                              }
                              maxLength="3" // Adjust as needed
                              className="table-input"
                              onInput={(e) => {
                                let val = e.target.value;
                                if (row.name === "unattempted_marks") {
                                  e.target.value = val === "0" ? "0" : "";
                                } else if (
                                  row.name === "wrong_option_level_marks" ||
                                  row.name === "wrong_ques_level_marks"
                                ) {
                                  // Allow only negative numbers or zero for wrong_ques_level_marks and wrong_option_level_marks
                                  if (val === "") {
                                    e.target.value = "";
                                  } else if (
                                    val !== "0" &&
                                    !val.startsWith("-")
                                  ) {
                                    e.target.value =
                                      "-" + val.replace(/[^0-9]/g, "");
                                  } else {
                                    e.target.value = val.replace(
                                      /[^-0-9]/g,
                                      ""
                                    );
                                  }
                                } else {
                                  e.target.value = val.replace(/[^-0-9]/g, "");
                                }
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="arrows-container-level">
                    <PiArrowFatUpThin
                      className="arrow-up-level"
                      onClick={moveRowUp}
                    />
                    <PiArrowFatDownThin
                      className="arrow-down-level"
                      onClick={moveRowDown}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateTestSection;
